import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/contas/listar'


function ListarContasScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Documentos da Prestação de Contas" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarContasScreen;